import { IUrlApi } from './../interfaces/urls.model';
import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppApiInterface } from 'src/app/app.api';
import { BaseModel } from '../models/base.model';


@Injectable({providedIn: 'root'})
export abstract class BaseService<T extends BaseModel>{

    protected http:HttpClient;

    protected _obj: BehaviorSubject<T>;

    protected copyJsonDataToObjectFunction:(jsonData:any)=>T;

    protected urls:IUrlApi;

    constructor(
        protected injector:Injector
    ) {
        this.http=this.injector.get(HttpClient)
        this._obj=new BehaviorSubject<T>(null)
    }

    // get section
    getAll(params:string=''):Observable<T[]>{
        return this.http.get(`${AppApiInterface.IMALI_API}/${this.urls.getAllUrl}?${params}`)
        .pipe(map((jsonData:any)=>this.buildArrayOfObjects(jsonData.data || jsonData)))
    }

    getObjectById(idobject:number):Observable<T>{
        return this.http.get(`${AppApiInterface.IMALI_API}/${this.urls.getByIdUrl}/${idobject}`)
        .pipe(map((jsonData:any)=>this.copyJsonDataToObjectFunction(jsonData.data || jsonData)))
    }

    getObject(objType:string):Observable<T>{
        return this._obj.pipe(map(obj=>{
            if(!obj) return this.copyJsonDataToObjectFunction(JSON.parse(localStorage.getItem(objType)))

            return obj
        }))
    }

    // create section
    create(data:T):Observable<string>{
        return this.http.post<any>(`${AppApiInterface.IMALI_API}/${this.urls.saveUrl}`, data)
            .pipe(map(data => data.message || data))
    }

    createDataWithImage(data:FormData):Observable<string>{
        return this.http.post<any>(`${AppApiInterface.IMALI_API}/${this.urls.saveUrl}`, data)
            .pipe(map(data => data.message || data))
    }

    createImageWithNoData(data:FormData):Observable<string>{
        return this.http.post<any>(`${AppApiInterface.IMALI_API}/${this.urls.saveImageWithNoDataUrl}`, data)
        .pipe(map(data => data.message || data))
    }

    // update section
    update(data:T):Observable<string>{
        return this.http.post<any>(`${AppApiInterface.IMALI_API}/${this.urls.updateUrl}/${data.id}`, data)
        .pipe(map(data => data.message || data))
    }

    updateDataWithImage(data:FormData):Observable<string>{
        return this.http.post<any>(`${AppApiInterface.IMALI_API}/${this.urls.updateUrl}/${data.get('id')}`, data)
            .pipe(map(data => data.message || data))
    }

    updateImageWithNoData(data:FormData,objectTypeName:string):Observable<string>{
        return this.http.post<any>(`${AppApiInterface.IMALI_API}/${this.urls.updateImageWithNoDataUrl}/${data.get('id')}`, data)
        .pipe(map(data => {

            this.setObject(this.copyJsonDataToObjectFunction(data.data || data),objectTypeName)

            return data.message;
        }))
    }

    updateIndividualImage(data:FormData,objectTypeName:string):Observable<string>{
        return this.http.post<any>(`${AppApiInterface.IMALI_API}/${this.urls.updateIndividualImage}/${data.get('id')}`, data)
        .pipe(map(data => {

            this.setObject(this.copyJsonDataToObjectFunction(data.data || data),objectTypeName)

            return data.message;
        }))
    }

    updateStatus(data:T):Observable<any>{
        return this.http.get<any>(`${AppApiInterface.IMALI_API}/${this.urls.statusUrl}/${data.id}`)
        .pipe(map(data => {return data }))
    }

    // delete section
    delete(id:number):Observable<string>{
        return this.http.get(`${AppApiInterface.IMALI_API}/${this.urls.deleteUrl}/${id}`)
        .pipe(map((jsonData:any)=>jsonData.message || jsonData))
    }

    // set section
    setObject(object:T,objType:string){

        this._obj.next(object)

        if(!!objType)
            localStorage.setItem(objType,JSON.stringify(object))
    }

    buildArrayOfObjects(jsonDataArray: any[]): T[] {

        let objects:Array<T>=new Array<T>()

        jsonDataArray.forEach(element=>{
          objects.unshift(this.copyJsonDataToObjectFunction(element))
        })

        return objects
    }

}

